import {
  AlertColor,
  Box,
  Button,
  styled,
  TextField,
  Theme,
  useMediaQuery,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { globalTheme } from "../../../common/theme";
import createStyles from "@mui/styles/createStyles";
import axios from "axios";
import React from "react";
import { SnackBarMessage, SnackBarMessageProps } from "../../component/SnackBarMessage";
import Title from "../../component/Title";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { GridCellParams, GridColumns, GridToolbarContainer, GridValueSetterParams } from "@mui/x-data-grid";
import { Add } from "@mui/icons-material";
import { renewToken } from "../../../services/AuthService";
import { useConstructor } from "../../../common/UseConstructor";
import { DeliveryMethodComboItem } from "./DeliveryMethodAccessories";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
  })
);

const StyledBox = styled(Box)(({ theme }) => ({
  height: "100%",
  width: "100%",
  "& .super-app-theme--cell": {
    backgroundColor: "rgba(41, 67, 63, 0.90)"
  },
}));

export function DeliveryMethodManagement() {
  const style = { ...useStyles(), ...globalTheme() };

  const tinyScreen = useMediaQuery('(max-width:1366px)');
  const smallScreen = useMediaQuery('(max-width:1920px)');
  const normalScreen = useMediaQuery('(max-width:2560px)');

  const [loading, setLoading] = React.useState<boolean>(false);

  const hasChanges = React.useRef<boolean>(false);

  const [gridData, setGridData] = React.useState<DeliveryMethodComboItem[]>([]);

  //Grid columns
  const columns: GridColumns = [
    { field: 'deliveryMethodDescription', headerName: 'Delivery Method', flex: 1, type: 'string', editable: true,
        valueSetter: (param: GridValueSetterParams) => onValueChanged(param),
        cellClassName: (params: GridCellParams<number>) => {
          if (params.value == null) {
            return "";
          }

          if (params.row.id == 0)
            return "super-app-theme--cell";
          else
            return "";
      }
    }
  ];
  
  function onValueChanged(param: GridValueSetterParams) {
    let row: DeliveryMethodComboItem = param.row;

    if (row.deliveryMethodDescription != param.value)
    {
      hasChanges.current = true;

      let oldDescription = row.deliveryMethodDescription;
      row.deliveryMethodDescription = param.value.slice(0, 80); 

      EditDeliveryMethod(oldDescription, param.value.slice(0, 80));
    }

    return { ...param.row, row };
  }
  
  //Dialogs and snacks
  const [snackSettings, setSnackSettings] =
    React.useState<SnackBarMessageProps>({
      open: false,
      message: "",
      subMessage: "",
      severity: undefined,
      onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
    });

  function showSnackBar(message: string, subMessage: string, colour?: AlertColor) {
    setSnackSettings({
      open: true,
      message: message,
      subMessage: subMessage,
      severity: colour,
      onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
    });
  }

  function DeliveryMethodToolbar() {
    const [inputText, setInputText] = React.useState("");
    return (
      <GridToolbarContainer style={{ display: 'flex' }}>
        <TextField className={style.ModalContentFieldHalfWidth}
          style={{ minWidth: '100px', width: '100%' }}
          label="Delivery method description"
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          size="small"            
        />
        <div style={{ width: "10px", minWidth: "10px" }}></div>
        <Button style={{ width: tinyScreen ? "60px" : (smallScreen ? "75px" : "90px"), minWidth: tinyScreen ? "60px" : (smallScreen ? "75px" : "90px") }}
          variant="contained" size="small" color="secondary" startIcon={<Add />} onClick={() => NewDeliveryMethod(inputText)}>Add</Button>
        <div style={{ width: "10px", minWidth: "10px" }}></div>
      </GridToolbarContainer>
    );
  }

  function NewDeliveryMethod(deliveryMethodDescription: string) {
    if (gridData.findIndex(x => x.deliveryMethodDescription == deliveryMethodDescription) > -1)
    {
      showSnackBar("Delivery method already exists", "", "error");
      return;
    }
    if (deliveryMethodDescription=="")
    {
      showSnackBar("Please enter a description for the delivery method.", "", "error");
      return;
    }

    let newDeliveryMethod: DeliveryMethodComboItem = {
      deliveryMethodDescription: deliveryMethodDescription
    }

    axios.post<DeliveryMethodComboItem>('Api/V1/DeliveryMethod', newDeliveryMethod).then(
      (result) => {
        let temp = [...gridData];
        temp.unshift(result.data);
        setGridData(temp);
        hasChanges.current = false;
        showSnackBar("Delivery method created successfully.", "", "success");
      },
      (error) => {
        showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
      }
    );
  }

  function EditDeliveryMethod(oldDescription: string, newDescription: string) {
    if (newDescription=="")
    {
      showSnackBar("Please enter a description for the delivery method.", "", "error");
    }

    axios.put<DeliveryMethodComboItem>('Api/V1/DeliveryMethod', {}, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      params: {
        'oldDeliveryMethod': oldDescription,
        'newDeliveryMethod': newDescription
      }
    }).then(
      (result) => {
        if (result.data.deliveryMethodDescription==oldDescription)
        {
          showSnackBar("Delivery method already exists.", "", "error");
          let tempGridData = [...gridData];
          let index = tempGridData.findIndex(x => x.deliveryMethodDescription == newDescription);
          let deliveryMethod = tempGridData[index];
          deliveryMethod.deliveryMethodDescription = oldDescription;
          tempGridData[index] = deliveryMethod;
          setGridData(tempGridData);
        }
        else
        {
          hasChanges.current = false;
          showSnackBar("Delivery method updated successfully.", "", "success");
        }
      },
      (error) => {
        showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
      }
    );
  }

  function SearchDeliveryMethod() {
    setLoading(true);

    axios.get<DeliveryMethodComboItem[]>('Api/V1/DeliveryMethod', {
      headers: {
        'Content-Encoding': 'gzip'
      }
    })
      .then((result) => {
        setGridData(result.data)
        setLoading(false);
      },
        (error) => {
          setGridData([]);
          setLoading(false);
          console.log(error);
          showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
        }
      )
      .catch((error) => {
        setLoading(false);
        console.log(error);
        showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
      });
  }

  useConstructor(() => Initialise())
  function Initialise() {
    renewToken();
    
    hasChanges.current = false;
    SearchDeliveryMethod();
  }

  return (
      <div className={style.PageMain}>
          <Title pageTitle="Delivery Method Management" />
          <div className={style.PageContent}>
            <div className={style.ModalContent}>
              <div className={style.PageFieldsFullHeight}>
                <div className={style.ModalContentFieldHalfWidth} style={{minWidth: 300}}>
                  <StyledBox>
                    <DataGridPro
                      getRowId={(row) => row.deliveryMethodDescription}
                      rows={gridData}
                      columns={columns}
                      loading={loading}
                      components={{
                        Toolbar: DeliveryMethodToolbar
                      }}
                      rowHeight={tinyScreen ? 20 : (smallScreen ? 24 : 28)}
                    />
                  </StyledBox>
                </div>
              </div>
            </div>
          </div>

        <SnackBarMessage {...snackSettings} />
      </div>
  );


}

